import React, { useEffect, useState } from "react"
import { Grid, makeStyles } from "@material-ui/core"
import WithDrawer from "../../components/common/drawer/withDrawer"
import {
	TotalFiles,
	FileTypesGraph,
	EmailSender,
	RecentActivity,
	EmailReceiver,
	ReviewOverview,
	UserReviewOverview,
} from "../../components/dashboard"
import { useDispatch, useSelector } from "react-redux"
import { getAnalyticsRequest } from "../../actions/dashboardActions"
import { getAuditDetails } from "../../actions/auditActions"
import { getAllReviewListRequest } from "../../actions/reviewActions"
import { getReviewOverviewDetails } from "../../actions/infoActions"
import { roles } from "../../data/roles"
import TabularView from "../../components/dashboard/ReviewOverview/TabularView"
import ReviewOverviewHeader from "../../components/dashboard/ReviewOverviewDashboard"
import ReviewOverviewDashboard from "../../components/dashboard/ReviewOverviewDashboard"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
}))

const PageDashboard = () => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const [rerenderChartHandle, setRerenderChartHandle] = useState({ count: 0 })

	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const { total_file_count: totalFiles, file_type, email } = useSelector(({ dashboard }) => dashboard?.data)
	const isLoading = useSelector((state) => state.dashboard?.isLoading)
	const isCaseUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_User)
	const isCaseAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Case_Administrator)
	const isSuperUser = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.Super_User)
	const isSystemAdmin = useSelector((state) => state?.authtentication?.user?.user?.roles)?.includes(roles?.System_Administrator)

	const [selectedReceiver, setSelectedReceiver] = useState(null)

	useEffect(() => {
		dispatch(getAnalyticsRequest())
		const recentActivityLimit = isCaseAdmin ? 10 : !isCaseAdmin && isCaseUser ? 5 : 10
		dispatch(
			getAuditDetails({
				limit: recentActivityLimit,
				actions:
					// "actions=create_search&actions=create_concept&actions=add_tag&actions=delete_tag&actions=add_comment&actions=delete_comment&actions=update_comment&actions=download",
					"actions=create_search&actions=create_concept&actions=view&actions=add_review",
			})
		)
		//get All reviews List
		dispatch(getAllReviewListRequest())
	}, [selectedBaseId])

	return (
		<div className={classes.root}>
			<Grid container spacing={3}>
				{/********** Row-1 **********/}
				<Grid item lg={3} md={6} xs={12} sm={12}>
					<Grid container direction="column" justifyContent="center" spacing={2}>
						<Grid item>
							<TotalFiles totalFiles={totalFiles} isLoading={isLoading} />
						</Grid>
						<Grid item>
							<FileTypesGraph data={file_type} isLoading={isLoading} />
						</Grid>
					</Grid>
				</Grid>
				<Grid item lg={4} md={6} xs={12} sm={12}>
					<EmailSender
						setSelectedReceiver={setSelectedReceiver}
						rerenderChartHandle={rerenderChartHandle}
						setRerenderChartHandle={setRerenderChartHandle}
					/>
				</Grid>
				<Grid item lg={5} md={6} xs={12} sm={12}>
					<EmailReceiver selectedReceiver={selectedReceiver} data={email?.from_to_cc} defaultData={email?.to_cc?.slice(0, 10)} />
				</Grid>
				{/********** Row-2 **********/}
				<Grid item lg={3} md={6} xs={12} sm={12}>
					<RecentActivity />
				</Grid>

				{(isCaseAdmin || isCaseUser) && (
					<Grid item lg={9} md={6} xs={12} sm={12}>
						<Grid container direction="column" justifyContent="center" spacing={2}>
							<Grid item xs={12}>
								<ReviewOverviewDashboard />
							</Grid>
						</Grid>
					</Grid>
				)}

				<Grid item lg={6} md={6} xs={12} sm={12}></Grid>
				{/********** Row-3 **********/}
				<Grid item lg={6} md={6} xs={12} sm={12}></Grid>
				<Grid item lg={6} md={6} xs={12} sm={12}></Grid>
			</Grid>
		</div>
	)
}

export default WithDrawer(PageDashboard)
